import React, { useState, useEffect } from "react";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import "./OrderSummaryTopButtons.css";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";

function OrderSummaryTopButtons({ activeForm ,setActiveForm}) {

  const baseAPI = process.env.REACT_APP_API_URL;
  const [orderSummary, setOrderSummary] = useState([]);
  const location = useLocation();


  useEffect(() => {
    window.scrollTo(0, 0);    


    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);   

    const storedToken = JSON.parse(localStorage.getItem("accessToken"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}customerget/GetCustomerOrderSummary?relocation_id=` +
            Relocation_ID,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setOrderSummary(response.data.data);
          setFirstItem(response.data.data[0]);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }   

  }, []);

  const [firstItem, setFirstItem] = useState({
    JobType:"",
    delivery_type:"",
    delivery_type_name:"",
  });

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);

      return null;
    }
  }

  const handleEditClick = () => {
    setActiveForm({
      customerDetails: true, // Activate Step 1
      relocationDetails: false,
      petDetails: false,
      preview: false,
      documentation: false,
    });
  };

  const handleCustomerDetailsClick = () => {
    setActiveForm({
      customerDetails: true, // Activate Step 1
      relocationDetails: false,
      petDetails: false,
      preview: false,
      documentation: false,
    });
  }

  const handleRelocationDetailsClick = () => {
    setActiveForm({
      customerDetails: false, 
      relocationDetails: true, // Activate Step 2
      petDetails: false,
      preview: false,
      documentation: false,
    });
  }

  const handlePetDetailsClick = () => {
    setActiveForm({
      customerDetails: false, 
      relocationDetails: false, 
      petDetails: true, // Activate Step 3
      preview: false,
      documentation: false,
    });
  }

  const handleAllDetailsClick = () => {
    setActiveForm({
      customerDetails: false, 
      relocationDetails: false, 
      petDetails: false, 
      preview: true, // Activate Step 4
      documentation: false,
    });
  }

  return (
    <>
      <div className="d-flex app">
        <div
          className="container-fluid ordersummary-top-button-main"
          style={{ backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                height: "48px",
              }}
            >
              <div>
                <h1
                  className="mobile-top-button-head-hide p-0"
                  style={{ fontSize: "24px", marginBottom: "2rem" }}
                >
                  Order Summary |{" "}
                  <HomeOutlinedIcon
                    style={{ color: "#5B489D", width: "34px", height: "27px" }}
                  />{" "}
                  <span style={{ fontSize: "20px", color: "#6A6A6A" }}>
                    &gt; Order List
                  </span>{" "}
                  <span style={{ fontSize: "20px", color: "#6A6A6A" }}>
                    &gt; Order Summary
                  </span>
                </h1>
                <h1
                  className="mobile-top-button-head-show"
                  style={{ fontSize: "24px", marginBottom: "2rem" }}
                >
                  <HomeOutlinedIcon
                    style={{ color: "#5B489D", width: "27px", height: "22px" }}
                  />{" "}
                  <span style={{ fontSize: "16px", color: "#6A6A6A" }}>
                    &gt; Order List
                  </span>{" "}
                  <span style={{ fontSize: "16px", color: "#6A6A6A" }}>
                    &gt; Order Summary
                  </span>
                </h1>
              </div>
            </div>
            <div>
              <div
                className="container-fluid mobile-top-button-head-hide p-0"
                style={{
                  borderRadius: "8px",
                  boxShadow:
                    "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                  backgroundColor: "white",
                }}
              >
                {activeForm.preview ? (
                  <div
                    style={{ height: "94px" }}
                    className="row order-main-list px-0"
                  >
                    <div className="col-lg-8 col-md-8 order-main-list-left px-4">
                      <div className="d-flex justify-content-between align-items-center order-main-list-left-top">
                        <h4
                          style={{
                            color: "#3D3D3D",
                            fontSize: "24px",
                            borderBottom: "4px solid #5B489D",
                            marginBottom: "-5px",
                            fontWeight: "bold",
                          }}
                        >
                          INTERNATIONAL EXPORT - CARGO{" "}
                          <span
                            style={{
                              fontSize: "16px",
                              borderBottom: "10px solid white",
                              fontWeight: "600",
                            }}
                          >
                            (DOOR-TO-AIRPORT)
                          </span>
                        </h4>
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-4  p-0  d-flex justify-content-end align-items-center">
                      <div
                        style={{
                          border: "2px solid #6a6a6a",
                          padding: "7px",
                          borderRadius: "7px",
                        }}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <EditIcon
                          style={{ color: "#6a6a6a", marginRight: "auto" }}
                        />
                        <button
                          style={{
                            border: "none",
                            outline: "none",
                            backgroundColor: "white",
                          }}
                          className=""
                          onClick={handleEditClick}
                        >
                          EDIT
                        </button>
                      </div>
                    </div>
                    <div
                      style={{ marginLeft: "-33px" }}
                      className="col-lg-2 col-md-4  p-0  d-flex justify-content-center align-items-center"
                    >
                      <div
                        style={{
                          border: "2px solid #6a6a6a",
                          padding: "7px",
                          borderRadius: "7px",
                        }}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <MenuIcon
                          style={{ color: "#6a6a6a", marginRight: "auto" }}
                        />
                        <button
                          style={{
                            border: "none",
                            outline: "none",
                            backgroundColor: "white",
                          }}
                          className=""
                        >
                          ORDER LIST
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{ height: "94px" }}
                    className="row order-main-list px-4"
                  >
                    <div className="col-lg-10 col-md-8 order-main-list-left p-0">
                      <div className="d-flex justify-content-between align-items-center order-main-list-left-top">
                        <h4
                          style={{
                            color: "#3D3D3D",
                            fontSize: "24px",
                            borderBottom: "4px solid #5B489D",
                            marginBottom: "-5px",
                            fontWeight: "bold",
                          }}
                        >
                          {firstItem.JobType}{" "}
                          <span
                            style={{
                              fontSize: "16px",
                              borderBottom: "10px solid white",
                              fontWeight: "600",
                            }}
                          >
                            { `(${firstItem.delivery_type_name})`}
                          </span>
                        </h4>
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-4  p-0  d-flex justify-content-end align-items-center">
                      <div
                        style={{
                          border: "2px solid #6a6a6a",
                          padding: "7px",
                          borderRadius: "7px",
                        }}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <MenuIcon
                          style={{ color: "#6a6a6a", marginRight: "auto" }}
                        />
                        <button
                          style={{
                            border: "none",
                            outline: "none",
                            backgroundColor: "white",
                          }}
                          className=""
                        >
                          ORDER LIST
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="top-buttons-arrow-main p-0 container-fluid">
                <div style={{ height: "44px" }} className="row order-main-list">
                  <div
                    className={`col-2   ${
                      activeForm.customerDetails
                        ? "active-arrow-start"
                        : activeForm.relocationDetails ||
                          activeForm.petDetails ||
                          activeForm.preview ||
                          activeForm.documentation
                        ? "completed-arrow-start"
                        : "top-buttons-arrow-start"
                    }`}
                    onClick={handleCustomerDetailsClick}
                  >
                    <h4 style={{ marginBottom: "0px", fontWeight: "700" }}>
                      STEP 1
                    </h4>
                  </div>
                  <div
                    className={`col-2   ${
                      activeForm.relocationDetails
                        ? "active-arrow"
                        : activeForm.petDetails ||
                          activeForm.preview ||
                          activeForm.documentation
                        ? "completed-arrow"
                        : "top-buttons-arrow"
                    }`}
                    onClick={handleRelocationDetailsClick}
                  >
                    <h4 style={{ marginBottom: "0px", fontWeight: "bold" }}>
                      STEP 2
                    </h4>
                  </div>
                  <div
                    className={`col-2   ${
                      activeForm.petDetails
                        ? "active-arrow"
                        : activeForm.preview || activeForm.documentation
                        ? "completed-arrow"
                        : "top-buttons-arrow"
                    }`}
                    onClick={handlePetDetailsClick}
                  >
                    <h4 style={{ marginBottom: "0px", fontWeight: "bold" }}>
                      STEP 3
                    </h4>
                  </div>
                  <div
                    className={`col-2   ${
                      activeForm.preview
                        ? "active-arrow"
                        : activeForm.documentation
                        ? "completed-arrow"
                        : "top-buttons-arrow"
                    }`}
                    onClick={handleAllDetailsClick}
                  >
                    <h4 style={{ marginBottom: "0px", fontWeight: "bold" }}>
                      STEP 4
                    </h4>
                  </div>
                  <div
                    className={`col-2   ${
                      activeForm.documentation
                        ? "active-arrow-end"
                        : "top-buttons-arrow-end"
                    }`}
                  >
                    <h4 style={{ marginBottom: "0px", fontWeight: "bold" }}>
                      STEP 5
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OrderSummaryTopButtons;
